// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__nt+zU","tab":"Tabs_tab__IMJ79","active":"Tabs_active__gZpji","disabled":"Tabs_disabled__Vr8OR","tabContent":"Tabs_tabContent__bx5Pu"};